import { Route } from 'react-router-dom';
import { outOfNavRoutes, routes } from '../utils/constants/developerRoutes';
import { WorkflowRouter } from '../routes/workflows/WorkflowRouter';
import { TemplateMailRouter } from '../routes/email/TemplateMailRouter';
import { MailRouter } from '../routes/mails/MailsRouter';
import { BaseRouter } from './BaseRouter';
import { MailSenderRouter } from '../routes/mail-sender/MailSenderRouter';

/**
 * DeveloperRouter component.
 *
 * This component represents the router for the developer section of the application.
 * It handles the routing for various developer-related pages and components.
 * @returns {ReactElement} The DeveloperRouter component.
 */
export const DeveloperRouter = () => (
  <BaseRouter
    routes={routes}
    outOfNavRoutes={outOfNavRoutes}
    useIndexForDashboard={false}
    additionalRoutes={[
      <Route
        key="workflows"
        path={`${routes.WORKFLOWS}/*`}
        element={<WorkflowRouter />}
      />,
      <Route
        key="template-mails"
        path={`${routes.TEMPLATE_MAILS}/*`}
        element={<TemplateMailRouter />}
      />,
      <Route key="mails" path={`${routes.MAILS}/*`} element={<MailRouter />} />,
      <Route
        key="mail-sender"
        path={`${routes.MAIL_SENDER}/*`}
        element={<MailSenderRouter />}
      />
    ]}
  />
);
